import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const getMargin = props => props.theme.separator.margin || '24px 0 28px 0'
const getPortraitMargin = props => props.theme.separator.portraitMargin
const getLandscapeMargin = props => props.theme.separator.landscapeMargin || '24px 0 28px 0'
const getPadding = props => props.theme.separator.padding

const SeparatorView = styled.div`
  display: flex;
  margin: ${getMargin};
  padding: ${getPadding};

  ${breakpoint('portrait')`
      margin: ${getPortraitMargin};
  `};

  ${breakpoint('landscape')`
      margin: ${getLandscapeMargin};
  `};
`

export default SeparatorView
